import jsonpath from 'jsonpath';
import { Action } from 'redux';

import {
  MainAction,
  MainActionConstants,
  MainState,
  OpenMessageBoxArgs,
  OpenSettingPopupArgs,
  OpenSnackBarArgs,
  SetUpdatedProfileArgs,
  UpdateProfileFieldArgs,
} from './types';

export const initialState: MainState = {
  isMessageBoxOpen: false,
  settingsPopup: {
    isOpen: false,
  },
  snackbarInfo: {
    isSnackbarOpen: false,
  },
  networkStates: {
    updateProfileRequest: { isRequesting: false },
    updatePasswordRequest: { isRequesting: false },
  },
};

export default function mainReducer(
  state = initialState,
  action: Action<MainActionConstants>,
): MainState {
  switch (action.type) {
    case MainActionConstants.MESSAGE_BOX_OPEN: {
      const act = action as MainAction<OpenMessageBoxArgs>;
      return {
        ...state,
        isMessageBoxOpen: true,
        messageBoxInfo: {
          ...act,
        },
      };
    }
    case MainActionConstants.MESSAGE_BOX_CLOSE: {
      return {
        ...state,
        isMessageBoxOpen: false,
      };
    }
    case MainActionConstants.SNACK_BAR_OPEN: {
      const act = action as MainAction<OpenSnackBarArgs>;
      return {
        ...state,
        snackbarInfo: {
          ...act,
          isSnackbarOpen: true,
        },
      };
    }
    case MainActionConstants.SNACK_BAR_CLOSE: {
      return {
        ...state,
        snackbarInfo: {
          ...state.snackbarInfo,
          isSnackbarOpen: false,
        },
      };
    }
    case MainActionConstants.SETTINGS_POPUP_OPEN: {
      const act = action as MainAction<OpenSettingPopupArgs>;
      return {
        ...state,
        settingsPopup: {
          isOpen: true,
          userProfile: act,
        },
      };
    }
    case MainActionConstants.SETTINGS_POPUP_CLOSE: {
      return {
        ...state,
        settingsPopup: {
          isOpen: false,
          userProfile: undefined,
        },
      };
    }
    case MainActionConstants.PROFILE_FIELD_UPDATE: {
      const act = action as MainAction<UpdateProfileFieldArgs>;
      const param = state.settingsPopup || {};
      jsonpath.value(param, `$.userProfile.${act.path}`, act.value);

      return {
        ...state,
        settingsPopup: {
          ...param,
        },
      };
    }
    case MainActionConstants.PROFILE_UPDATE: {
      return {
        ...state,
        networkStates: {
          ...state.networkStates,
          updateProfileRequest: {
            ...state.networkStates.updateProfileRequest,
            isRequesting: true,
          },
        },
      };
    }
    case MainActionConstants.PROFILE_UPDATED_SET: {
      const act = (action as MainAction<SetUpdatedProfileArgs>);
      return {
        ...state,
        networkStates: {
          ...state.networkStates,
          updateProfileRequest: {
            isRequesting: false,
            lastError: act.error,
          },
        },
      };
    }
    case MainActionConstants.PASSWORD_UPDATE: {
      return {
        ...state,
        networkStates: {
          ...state.networkStates,
          updatePasswordRequest: {
            ...state.networkStates.updatePasswordRequest,
            isRequesting: true,
          },
        },
      };
    }
    case MainActionConstants.PASSWORD_UPDATED_SET: {
      const act = (action as MainAction<SetUpdatedProfileArgs>);
      return {
        ...state,
        networkStates: {
          ...state.networkStates,
          updatePasswordRequest: {
            isRequesting: false,
            lastError: act.error,
          },
        },
      };
    }
    default:
      return state;
  }
}
